export const AdminString = "ADMIN";
export const CustomerString = "CUSTOMER";
export const ProviderString = "PROVIDER";
// export const UrlString = "http://localhost:3000";
export const UrlString = "https://service-master-be.onrender.com";